import TourProductObjectValue from '@/js/common/Domain/ObjectValue/TourProduct';

export default Backbone.Collection.extend({
    model: TourProductObjectValue,
});
